import { ChatMember } from './chat-member';

export interface ChatMemberList {
  participants: ChatMember[];
  targetParticipants: ChatMember[];
}
